"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTab = exports.isTabs = exports.formatContent = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var formatContent = function (type, content) {
    if (type === 'text')
        return content;
    var bulletIcon = type === 'check' ? react_1.default.createElement("i", { className: 'ss-check text-wisteria' }) : react_1.default.createElement("i", { className: 'ss-delete text-sea-pink' });
    var bulletPoints = (content === null || content === void 0 ? void 0 : content.split(';')) || [];
    return bulletPoints.map(function (bullet, i) {
        return (react_1.default.createElement("div", { key: 'bullet' + i, style: { marginLeft: '-1rem' } },
            react_1.default.createElement("span", { className: 'padding-right-2' }, bulletIcon),
            " ",
            bullet));
    });
};
exports.formatContent = formatContent;
var FeatureTabs = function (_a) {
    var tabs = _a.tabs, className = _a.className;
    (0, react_1.useEffect)(function () {
        // only initialize foundation tabs once
        new Foundation.Tabs($('[data-tabs]'));
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('feature-tabs', className) },
        react_1.default.createElement("ul", { className: 'tabs flex-container text-center', "data-tabs": true, id: 'feature' }, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, i) {
            var title = tab.title;
            return (react_1.default.createElement("li", { className: (0, classnames_1.default)('tabs-title flex-child-auto', i === 0 && 'is-active'), key: 'title' + i },
                react_1.default.createElement("a", { href: '#content' + i, "aria-selected": 'true' }, title)));
        })),
        react_1.default.createElement("div", { className: 'tabs-content', "data-tabs-content": 'feature' }, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, i) {
            var type = tab.type, body = tab.body, content = tab.content;
            var bulletContent = (0, exports.formatContent)(type, content);
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)('tabs-panel', i === 0 && 'is-active'), id: 'content' + i, key: 'content' + i },
                body && react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: body } }),
                typeof bulletContent === 'string' ? react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: bulletContent } }) : react_1.default.createElement("div", { className: 'space-y-4' }, bulletContent)));
        }))));
};
exports.default = FeatureTabs;
var isTabs = function (value) {
    var e_1, _a;
    var typedValue = value;
    if (!typedValue)
        return true;
    try {
        for (var typedValue_1 = __values(typedValue), typedValue_1_1 = typedValue_1.next(); !typedValue_1_1.done; typedValue_1_1 = typedValue_1.next()) {
            var tab = typedValue_1_1.value;
            if (!(0, exports.isTab)(tab))
                return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (typedValue_1_1 && !typedValue_1_1.done && (_a = typedValue_1.return)) _a.call(typedValue_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
exports.isTabs = isTabs;
var isTab = function (value) {
    var typedValue = value;
    return (typedValue &&
        typeof typedValue.type === 'string' &&
        typeof typedValue.title === 'string' &&
        (!typedValue.body || typeof typedValue.body === 'string') &&
        (!typedValue.content || typeof typedValue.content === 'string'));
};
exports.isTab = isTab;
